import * as React from "react";
import "./activityIcon.scss";
import IconLarge from "../../atoms/Icon/IconLarge";

interface IProps {
	/**
	 * Growler icon.
	 */
	icon: string;
	/**
	 * Activity icon color name.
	 */
	color: "orange" | "yellow" | "green" | "noteYellow" | "burgundy" | "blue" | "yellow" | "white";
	/**
	 * Background color variant.
	 */
	variant?: "white" | "orange" | "green";
}

const ActivityIcon: React.SFC<IProps> = (props) => {
	return (
		<div className={`m-activity-icon is-${props.color}`}>
			<IconLarge icon={props.icon} variant={props.variant ? props.variant : "white"}/>
		</div>
	);
};

export default ActivityIcon;
